import type { AxiosPromise } from 'axios';
import BaseClient from './BaseClient';
import type {
    KioskTeamGroupView,
    KioskTeamGroupViewCreatePayload,
    KioskTeamGroupViewUpdatePayload,
} from './adminTeamGroupViewsClient.types';

class AdminTeamGroupViewsClient extends BaseClient {
    getViews(teamId: number): AxiosPromise<{ data: KioskTeamGroupView[] }> {
        const url = `/api/admin/teams/${teamId}/group-views`;
        return this.makeCoreApiRequest(url, 'get');
    }

    getView(teamId: number, viewId: number): AxiosPromise<KioskTeamGroupView> {
        const url = `/api/admin/teams/${teamId}/group-views/${viewId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    createView(teamId: number, payload: KioskTeamGroupViewCreatePayload): AxiosPromise<KioskTeamGroupView> {
        const url = `/api/admin/teams/${teamId}/group-views`;
        return this.makeCoreApiRequest(url, 'post', payload);
    }

    updateView(
        teamId: number,
        viewId: number,
        payload: KioskTeamGroupViewUpdatePayload
    ): AxiosPromise<KioskTeamGroupView> {
        const url = `/api/admin/teams/${teamId}/group-views/${viewId}`;
        return this.makeCoreApiRequest(url, 'patch', payload);
    }

    duplicateView(teamId: number, viewId: number, name: string): AxiosPromise<KioskTeamGroupView> {
        const url = `/api/admin/teams/${teamId}/group-views/${viewId}/duplicate`;
        return this.makeCoreApiRequest(url, 'post', { name });
    }

    deleteView(teamId: number, viewId: number): AxiosPromise<void> {
        const url = `/api/admin/teams/${teamId}/group-views/${viewId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}

export default new AdminTeamGroupViewsClient();
